import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary, ErrorPanel } from './components/ErrorBoundary';
import { reloadOnceForStaleChunk } from './lib/chunk-reload';
import { pendingButtonMutationCache } from './lib/mutation-pending';
import './index.css';
import { applyTheme } from './lib/theme';

applyTheme();

// Vite fires this when a page chunk's preload fails (old tab after a deploy): reload once.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

const queryClient = new QueryClient({
  mutationCache: pendingButtonMutationCache(),
  defaultOptions: { queries: { retry: 1, staleTime: 10_000 } },
});
const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Last line of defence; page errors are caught closer, inside Layout. */}
      <ErrorBoundary
        fallback={(error) => (
          <div className="mx-auto max-w-xl p-6">
            <ErrorPanel error={error} />
          </div>
        )}
      >
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
